
import { connect } from 'react-redux';
import ManageContentView from "./view"
import {
  selectAsset, deselectAsset, invalidateAssetSelection,
  selectCollection, removeCollectionSelection, invalidateCollectionsSelection
} from 'src/legacy/redux/actions/selection.jsx';
import _ from 'lodash';
import { fetchFolio } from 'src/legacy/redux/actions/folios';

const mapStateToProps = (state, ownProps) => {
  let assets = state.legacyRootReducer.selection.assets;
  let collectionId = _.get(state, 'legacyRootReducer.selection.collections.0.id');
  let collection = _.get(state, 'legacyRootReducer.selection.collections.0');

  if (collectionId) {
    const collectionObject = _.get(state, `legacyRootReducer.myCollections.folios.folio[${collectionId}].item`);

    if(collectionObject){
      collection = collectionObject;
    }
  }

  if (collection) {
    assets = (collection.assets || [])
      .filter(asset => asset.settings && asset.settings.share)
      .map(asset => {
        return {
          type: 'asset',
          asset: asset
        }
      })
  }

  return {
    collection: collection,
    assets: assets.map(asset => asset.asset),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    selectAsset: (asset) => {
      return dispatch(selectAsset(asset));
    },

    deselectAsset: (asset) => {
      return dispatch(deselectAsset(asset));
    },

    selectCollection: (collection) => {
      return dispatch(selectCollection(collection));
    },

    removeCollectionSelection: (collection) => {
      return dispatch(removeCollectionSelection(collection));
    },

    invalidateCollectionsSelection: () => {
      return dispatch(invalidateCollectionsSelection());
    },
    invalidateAssetSelection: () => {
      return dispatch(invalidateAssetSelection());
    },

    fetchFolio: (folioId) => {
      return dispatch(fetchFolio(folioId));
    }
  }
}

const ManageContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageContentView);

export default ManageContentContainer;
